import React, { useContext, useMemo } from 'react';
import { useQueryClient } from 'react-query';

const CardContext = React.createContext(null);

export function CardContextProvider(props) {
    const cardContextValue = useMemo(
        () => ({
            cardType: props.type, 
            cardTitle: props.cardTitle,
            draggable: props.draggable,
            componentName: props.componentName
        }),
        [props.type, props.cardTitle, props.draggable, props.componentName]
    );

    //render
    return useMemo(
        () => (
            <CardContext.Provider value={cardContextValue}> 
                {props.children}
            </CardContext.Provider>
        ), [cardContextValue, props.children]
    );
}

export default function useCard() {
    const { 
        cardType, 
        cardTitle, 
        draggable,
        componentName
    } = useContext(CardContext);

    const queryClient = useQueryClient();

    return useMemo(
        () => ({
            cardType,
            cardTitle,
            draggable,
            componentName,
            refreshCard: () => { queryClient.invalidateQueries(componentName); }
        }), 
        [cardType, cardTitle, draggable, componentName, queryClient]
    );
}